import GeoJSON from 'ol/format/GeoJSON';
import LayerVector from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Select from 'ol/interaction/Select';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import MultiPolygon from 'ol/geom/MultiPolygon';
import MultiPoint from 'ol/geom/MultiPoint';
import MultiLineString from 'ol/geom/MultiLineString';
import GeometryCollection from 'ol/geom/GeometryCollection';
import Overlay from 'ol/Overlay';
import { unByKey } from 'ol/Observable';
import pointIcon from '@disy/cadenza-icons/map-marker.svg';
import lineIcon from '@disy/cadenza-icons/line.svg';
import polygonIcon from '@disy/cadenza-icons/polygon.svg';
import selectIcon from '@disy/cadenza-icons/polygon-selection.svg';

import { convertStyle } from 'cadenza/map/convert-style';
import { ClassicDrawModifyInteractionGroup } from 'cadenza/map/interactions/classic/classic-draw-modify-interaction-group';
import { MapProperty } from 'cadenza/map/map-property';
import { LayerProperty } from 'cadenza/map/layer-property';
import { context } from 'cadenza/map/context/context';
import { WpsMarkerPopup, getMarkersLayerStyle } from 'cadenza/map/wps/wps-marker';
import { WpsInteraction } from 'cadenza/map/wps/wps-interaction';
import { HIT_TOLERANCE } from 'cadenza/map/map-constants';
import { icon } from 'cadenza/utils/icon/icon';
import 'cadenza/legacy-dialog/legacy-dialog';
import { errorAlert } from 'cadenza/alert';

window.ol_overlay = Overlay;
window.ol_format_GeoJSON = GeoJSON;
window.ol_layer_Vector = LayerVector;
window.ol_source_Vector = VectorSource;
window.ol_interaction_DrawModify = ClassicDrawModifyInteractionGroup;
window.ol_interaction_Select = Select;
window.ol_Feature = Feature;
window.ol_geom_Point = Point;
window.ol_geom_MultiPoint = MultiPoint;
window.ol_geom_MultiLineString = MultiLineString;
window.ol_geom_MultiPolygon = MultiPolygon;
window.ol_geom_GeometryCollection = GeometryCollection;
window.ol_Observable_unByKey = unByKey;
window.wps_MapProperty = MapProperty;
window.wps_LayerProperty = LayerProperty;
window.wps_mapContext = context;
window.wps_ErrorAlert = errorAlert;
window.wps_MarkerPopup = WpsMarkerPopup;
window.wps_Interaction = WpsInteraction;
window.wps_getMarkersLayerStyle = getMarkersLayerStyle;
window.wps_convertStyle = convertStyle;
window.wps_hitTolerance = HIT_TOLERANCE;
window.wps_icon = icon;

window.wps_icons = {
  wpsControlFeatureSelector: selectIcon,

  wpsControlDrawPoint: pointIcon,
  wpsControlDrawMultiPoint: pointIcon,
  wpsControlModifyPoint: pointIcon,
  wpsControlModifyMultiPoint: pointIcon,

  wpsControlDrawLineString: lineIcon,
  wpsControlDrawMultiLineString: lineIcon,
  wpsControlModifyLineString: lineIcon,
  wpsControlModifyMultiLineString: lineIcon,

  wpsControlDrawPolygon: polygonIcon,
  wpsControlDrawMultiPolygon: polygonIcon,
  wpsControlModifyPolygon: polygonIcon,
  wpsControlModifyMultiPolygon: polygonIcon
};
